export enum ContestSide {
  REQUESTER = 'REQUESTER',
  DEFENDANT = 'DEFENDANT'
}
